import { useRef } from 'react';

export function useInstance<T>(initialState: T | (() => T)): T {
  const ref = useRef<T | null>(null);

  if (ref.current === null) {
    ref.current =
      initialState instanceof Function ? initialState() : initialState;
  }

  return ref.current;
}
